export default __webpack_public_path__ + "static/media/logo-ini3.b9d9b5eb.png";